module.exports = __webpack_public_path__ + "img/icon_cancel.08d33352.svg";